import { AdditionalProductFragment } from '@graphql/generated/graphql';
import { useEmbedContext } from '@lib/embed/providers/EmbedProvider';
import { isVariantInStock } from '@utils/variant';

export const useHasAddToCart = (
    additionalProduct: AdditionalProductFragment
) => {
    const { isStoryBundle } = useEmbedContext();

    return {
        hasAddToCart:
            isStoryBundle &&
            (additionalProduct.Variants || []).filter(isVariantInStock).length >
                0,
    };
};
